module.exports = __webpack_public_path__ + "img/052.5933baf4.jpeg";